<template>
  <image-viewer
    v-if="images.length"
    :images="images"
    class="qa-screenshot-viewer-bridge">
    <img
      v-for="image in images"
      :key="image"
      ref="imageEls"
      :src="image"
      alt="">
  </image-viewer>
</template>

<script setup>
import { nextTick, ref } from 'vue';
import ImageViewer from '@/Components/Common/ImageViewer.vue';

const images = ref([]);
const imageEls = ref([]);

const open = async (nextImages, index = 0) => {
  const normalized = Array.isArray(nextImages) ? nextImages.filter(Boolean) : [];
  if (!normalized.length) return;

  imageEls.value = [];
  images.value = normalized;
  await nextTick();

  const safeIndex = Math.min(Math.max(Number(index) || 0, 0), normalized.length - 1);
  imageEls.value[safeIndex]?.click();
};

defineExpose({ open });
</script>

<style scoped>
.qa-screenshot-viewer-bridge {
  position: fixed;
  left: -10000px;
  top: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>
